import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import { NgxCurrencyModule } from 'ngx-currency';

import { ParameterActServiceListModule } from 'src/app/modules/acts/parameter-act-service-list/parameter-act-service-list.module';
import { ParameterListModule } from 'src/app/modules/acts/parameter-list/parameter-list.module';
import { PersonFormModule } from 'src/app/generated/ui/form/Person/Person.module';
import { addressFormModule } from 'src/app/generated/ui/form/address/address.module';

import { ParamterDocumentUploaderModule } from 'src/app/modules/acts/parameter-document-uploader/parameter-document-uploader.module';
import { ParameterSwitchComponent } from './parameter-switch.component';
import { RentReportYearlyListSubDocModule } from 'src/app/generated/ui/listSubdoc/RentReportYearly/RentReportYearly.module';
import { RentReportMonthlyListSubDocModule } from 'src/app/generated/ui/listSubdoc/RentReportMonthly/RentReportMonthly.module';

import { DocumentFormAutoCompleteModule } from 'src/app/generated/ui/chipList/Document/Document.module';
import { ActFormAutoCompleteModule } from 'src/app/generated/ui//chipList/Act/Act.module';
import { ParamterComponentListControlerModule } from 'src/app/modules/acts/parameter-component-list-controler/parameter-component-list-controler.module';

import { ParameterDocumentLinkSelectorModule } from 'src/app/modules/acts/parameter-document-link-selector/parameter-document-link-selector.module';
import { DateModule } from 'src/app/modules/date/date.module';

import { ParameterStringModule } from '../parameter-string/parameter-string.module';

@NgModule({
  declarations: [ParameterSwitchComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatTooltipModule,

    NgxCurrencyModule,

    ParamterDocumentUploaderModule,
    ParameterActServiceListModule,
    ParameterListModule,

    PersonFormModule,
    addressFormModule,

    RentReportYearlyListSubDocModule,
    RentReportMonthlyListSubDocModule,
    DocumentFormAutoCompleteModule,
    ActFormAutoCompleteModule,
    ParamterComponentListControlerModule,
    ParameterDocumentLinkSelectorModule,
    DateModule,
    ParameterStringModule
  ],
  exports: [ParameterSwitchComponent]
})
export class ParameterSwitchModule {}
